import SavingsRetirementSvg from '~/@ui/_sharedSvgs/products/SavingsRetirement.svg?react'
import SavingsChildrenSvg from '~/@ui/_sharedSvgs/products/SavingsChildren.svg?react'
import SavingsInflationSvg from '~/@ui/_sharedSvgs/products/SavingsInflation.svg?react'
import ImagePlaceHolderSvg from '~/@ui/_sharedSvgs/ui/ImagePlaceHolder.svg?react'

type Props = {
  slug?: string
  mode?: 'light' | 'dark'
  proportionsClassNames?: string
}

export function OpportunityAvatar(props: Props) {
  const proportionsClassNames =
    props.proportionsClassNames ?? 'w-[72px] h-[72px]'
  const mode = props.mode ?? 'light'
  if (props.slug === 'zabezpecenie-financii-na-dochodok') {
    return (
      <SavingsRetirementSvg
        className={`flex-shrink-0 p-4 rounded-xl ${mode === 'light' ? 'bg-[#cbe4ff]' : 'bg-[#223549]'} ${proportionsClassNames}`}
      />
    )
  }

  if (props.slug === 'buducnost-mojich-deti') {
    return (
      <SavingsChildrenSvg
        className={`flex-shrink-0 p-4 rounded-xl ${mode === 'light' ? 'bg-[#ffe1f0]' : 'bg-[#463842]'} ${proportionsClassNames}`}
      />
    )
  }

  if (props.slug === 'sporte-a-porazte-inflaciu') {
    return (
      <SavingsInflationSvg
        className={`flex-shrink-0 p-4 rounded-xl ${mode === 'light' ? 'bg-[#ede2ff]' : 'bg-[#342a49]'} ${proportionsClassNames}`}
      />
    )
  }

  return (
    <ImagePlaceHolderSvg
      className={`p-4 bg-zBlack250 rounded w-16 h-16 ${proportionsClassNames}`}
    />
  )
}
